import React, { useState, useEffect } from "react";
import { Form, Row, Col, Input, Button, notification, Modal, Select, Tooltip } from "antd";
import { CloseOutlined, SaveOutlined, ExclamationCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { BreadcrumbAbrirChamado } from "../../components";

export default function ParametrosLocalSped() {
    const [formulario] = Form.useForm();
    const [carregando, setCarregando] = useState(false);
    const [consumoEnergiaEletricaGas, setConsumoEnergiaEletricaGas] = useState([]);
    const [tipoLigacaoEnergiaEletrica, setTipoLigacaoEnergiaEletrica] = useState([]);
    const [grupoTensaoEnergiaEletrica, setGrupoTensaoEnergiaEletrica] = useState([]);

    useEffect(() => {
        carregarDados();
    }, []);

    const salvarConf = valores => {
        let dados = { ...formulario.getFieldValue() };

        setCarregando(true);
        api.put('ParametroLocalSped/Editar', dados).then(
            res => {
                notification.success({ message: 'Operação concluída', description: "Configurações Sped salvos com sucesso!" });
            }).catch(
                error => {
                    setCarregando(false);
                    console.log(error);
                }).finally(
                    () => {
                        setCarregando(false);
                    });
    };

    function carregarDados() {

        api.get('Enum/Listar?nome=ConsumoEnergiaEletricaGas').then(res => {
            if (res.status === 200) {
                setConsumoEnergiaEletricaGas(res.data);
            }
        }).catch((erro) => console.error(erro));

        api.get('Enum/Listar?nome=TipoLigacaoEnergiaEletrica').then(res => {
            if (res.status === 200) {
                setTipoLigacaoEnergiaEletrica(res.data);
            }
        }).catch((erro) => console.error(erro));

        api.get('Enum/Listar?nome=GrupoTensaoEnergiaEletrica').then(res => {
            if (res.status === 200) {
                setGrupoTensaoEnergiaEletrica(res.data);
            }
        }).catch((erro) => console.error(erro));

        api.get(`ParametroLocalSped/BuscarParametros`).then(
            res => {
                if (!!res.data) {
                    var parametros = res.data;
                    formulario.setFieldsValue(parametros);
                }
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    };


    const onClose = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação e ignorar o que foi realizado até o momento?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                window.location = '/Home#/'
            }
        });
    };


    return (
        <div className="p-10">
            <BreadcrumbAbrirChamado />
            <Form layout="vertical" name="formParametrosLocalSped" form={formulario} onFinish={salvarConf}>
                <Row gutter={[8, 0]}>
                    <Form.Item name="psl_id" hidden><Input /></Form.Item>
                    <Col xl={3} lg={3} md={3} sm={6} xs={24}>
                        <Form.Item label="Código Receita" name="pls_codigoreceita">
                            <Input placeholder="Código Receita" maxLength={12} />
                        </Form.Item>
                    </Col>
                    <Col xl={3} lg={3} md={3} sm={6} xs={24}>
                        <Form.Item label="Conta Contabil Estoque" name="pls_contacontabilestoque">
                            <Input placeholder="Informe a Conta Contabil Estoque" maxLength={12} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={5} xl={5}>
                        <Form.Item name="pls_classeenergiaougas" label={
                            <div>
                                Classe de Consumo de Energia Elétrica ou Gás
                                <Tooltip title="Selecione um classe de consumo de energia elétrica ou gás">
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </div>
                        }>
                            <Select placeholder="Selecione o tipo de aviso" showSearch optionFilterProp="children" allowClear={true}>
                                {consumoEnergiaEletricaGas.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={4} xl={4}>
                        <Form.Item name="pls_tipoligacao" label={
                            <div>
                                Código do Tipo de Ligação
                                <Tooltip title="Selecione Código Tipo de Ligação">
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </div>
                        }>
                            <Select placeholder="Selecione o tipo de aviso" showSearch optionFilterProp="children" allowClear={true}>
                                {tipoLigacaoEnergiaEletrica.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={5} xl={5}>
                        <Form.Item name="pls_grupotensao" label={
                            <div>
                                Código do Grupo de Tensao
                                <Tooltip title="Selecione o grupo de tensao">
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </div>
                        }>
                            <Select placeholder="Selecione o tipo de aviso" showSearch optionFilterProp="children" allowClear={true}>
                                {grupoTensaoEnergiaEletrica.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <div className="ant-drawer-footer footer-recebimento">
                    <Row align="middle" justify="end" gutter={[8, 0]}>
                        <Col>
                            <Button loading={carregando} onClick={onClose} icon={<CloseOutlined />} size="large">
                                Cancelar
                            </Button>
                        </Col>
                        <Col>
                            <Button icon={<SaveOutlined />} type="primary" size="large" htmlType="submit">
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>
    );
}
